<template>
    <form @submit.prevent="submit" novalidate v-if="!complete && activeItem">
        <small>{{ vestigingTitle }}</small>
        <h2 class="h3 text-normal">{{ activeItem.title }}</h2>
        <h4 class="mt-4">Toelichting</h4>
        <p>{{ activeItem.toelichting }}</p>

        <!--Antwoord-->
        <div class="form-group mt-4" :class="{'error-shake has-invalid': $v.activeItem.antwoord.$error}">
            <div class="custom-control custom-radio small d-inline-block">
                <input type="radio" class="custom-control-input" id="antwoord-ja" name="antwoord" value="ja"
                       v-model.trim.lazy="$v.activeItem.antwoord.$model" @change="$v.activeItem.antwoord.$reset">
                <label class="custom-control-label grey" for="antwoord-ja">Ja</label>
            </div>
            <div class="custom-control custom-radio small d-inline-block">
                <input type="radio" class="custom-control-input" id="antwoord-nee" name="antwoord" value="nee"
                       v-model.trim.lazy="$v.activeItem.antwoord.$model" @change="$v.activeItem.antwoord.$reset">
                <label class="custom-control-label grey" for="antwoord-nee">Nee</label>
            </div>
            <div class="custom-control custom-radio small d-inline-block">
                <input type="radio" class="custom-control-input" id="antwoord-nvt" name="antwoord" value="nvt"
                       v-model.trim.lazy="$v.activeItem.antwoord.$model" @change="$v.activeItem.antwoord.$reset">
                <label class="custom-control-label grey" for="antwoord-nvt">N.v.t.</label>
            </div>
        </div>

        <!--Toelichting-->
        <div class="tab-content" v-show="activeItem.antwoord === 'ja' && activeItem.toelichting_ja">
            {{ activeItem.toelichting_ja }}
        </div>
        <div class="tab-content" v-show="activeItem.antwoord  === 'nee' && activeItem.toelichting_nee">
            {{ activeItem.toelichting_nee }}
        </div>

        <!--Antwoord toelichting-->
        <div class="form-group mt-4">
            <label for="antwoordToelichting" class="control-label">Leidt deze informatie voor u tot extra acties of aanpassingen op uw bedrijf? Zo ja, welke zijn dit?</label>
            <textarea id="antwoordToelichting" class="form-control" v-model.trim="activeItem.antwoordToelichting"></textarea>
        </div>

        <!-- Navigatie -->
        <div class="d-flex justify-content-between">
            <button type="button" v-if="activeIndex + 1 > 1" @click="activeIndex--" class="btn btn-link"><i class="fas fa-caret-left"></i> Vorige</button>
            <p class="small mb-0">Vraag {{ activeIndex + 1 }} van {{ items.length }}</p>
            <button type="submit" class="btn btn-link">{{ activeIndex + 1 === items.length ? 'Indienen' : 'Volgende' }} <i class="fas fa-caret-right"></i></button>
        </div>
    </form>
    <div v-else>
        <small>{{ vestigingTitle }}</small>
        <h2 class="h3 text-normal">Bedankt, u hebt {{ vragenlijstTitle }} afgerond.</h2>
        <p>U kunt uw afgeronde F-RIE vragenlijsten altijd inzien via uw profiel.</p>

        <div class="btn-group">
            <div class="dropdown">
                <button type="button" class="btn btn-primary dropdown-toggle mr-2" id="dropdownMenuButton">
                    PDF’s
                </button>
                <div aria-labelledby="dropdownMenuButton" class="dropdown-menu">
                    <a :href="'/pdf/' + antwoordsetId" target="_blank" class="dropdown-item" rel="nofollow noopener">Download PDF</a>
                    <a :href="'/pdf/' + antwoordsetId + '?toelichting'" target="_blank" class="dropdown-item" rel="nofollow noopener">Download PDF (met toelichting)</a>
                    <button type="button" @click="mailPdf($event)" class="dropdown-item">E-mail PDF</button>
                    <button type="button" @click="mailPdf($event, true)" class="dropdown-item">E-mail PDF (met toelichting)</button>
                </div>
            </div>
            <button type="button" class="btn btn-primary" @click="close">Afsluiten</button>
        </div>
    </div>
</template>

<script>
    import {required} from 'vuelidate/lib/validators'

    export default {
        props: {
            vragenlijstTitle: String,
            vragenlijstId: Number,
            closeLocation: String,
            antwoordsetIdProp: Number,
            vestigingId: Number,
            vestigingTitle: String,
            bedrijfId: Number,
            bedrijfTitle: String,
            redo: Boolean
        },
        data() {
            return {
                items: [],
                activeIndex: null,
                activeItem: {
                    antwoord: null,
                    antwoordToelichting: null,
                },
                antwoordsetId: 0,
                complete: false,
            }
        },
        validations: {
            activeItem: {
                antwoord: {
                    required,
                },
            }
        },
        created() {
            this.antwoordsetId = this.antwoordsetIdProp;

            let that = this;
            this.axios.get('/api/vragen/' + this.vragenlijstId + (this.antwoordsetId > 0 ? '/' + this.antwoordsetId : ''))
                .then(response => {
                    that.items = response.data;

                    let lastAnswer = _.findLastIndex(that.items, 'antwoord');

                    if(this.redo || (that.items.length - 1) < lastAnswer) {
                        that.activeIndex = 0;
                    } else if((that.items.length - 1) === lastAnswer) {
                        that.activeIndex = lastAnswer
                    } else {
                        that.activeIndex = lastAnswer + 1;
                    }
                })
                .catch(error => {
                    console.log(error);
                })
        },
        watch: {
            activeIndex() {
                this.activeItem = this.items[this.activeIndex];

                // Default to "nee"
                if (this.activeItem.antwoord === undefined) {
                    this.activeItem.antwoord = 'nee'
                }

                this.$v.$reset();
            }
        },
        methods: {
            submit() {
                this.$v.$touch();

                if (!this.$v.$invalid) {
                    let anwser = null;
                    if (this.activeItem.antwoord === 'ja') {
                        anwser = true;
                    } else if (this.activeItem.antwoord === 'nee') {
                        anwser = false;
                    }

                    this.axios.post('/antwoord/' + this.vragenlijstId + '/' + this.activeItem.id + (this.antwoordsetId ? '/' + this.antwoordsetId : ''), {
                        vestigingId: this.vestigingId,
                        antwoord: anwser,
                        toelichting: this.activeItem.antwoordToelichting,
                    }).then((response) => {
                        this.antwoordsetId = response.data.antwoordsetId;

                        if (this.activeIndex + 1 < this.items.length) {
                            this.items[this.activeIndex] = this.activeItem;
                            this.activeIndex++;
                        } else {
                            this.complete = true;
                        }
                    }).catch((error) => {

                    })
                }
            },
            mailPdf(event, withElucidation) {
                event.currentTarget.blur();

                this.axios.post('/mail/' + this.antwoordsetId + (withElucidation ? '?toelichting' : ''));

                this.$notify({
                    group: 'base',
                    text: 'U ontvangt zodadelijk een e-mail met de vragenlijst.',
                    type: 'alert-success',
                });
            },
            close() {
                location.href = this.closeLocation
            },
        }
    }
</script>